import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initServiceListAnimation = () => {
  const blocks = document.querySelectorAll("[data-wv-service-list]");

  if (!blocks.length) return;

  blocks.forEach((block) => {
    const topOverText = block.querySelector(".hero-content > .hero-flip-item");
    const title = block.querySelector(".hero-title");
    const items = block.querySelectorAll(".service-list > .services-grid-item");
    const marqueeBlock = block.querySelector(".wv-hero-marquee-block");
    const marqueeLines = marqueeBlock
      ? marqueeBlock.querySelectorAll(".wv-hero-marquee-line")
      : [];
    const overlay = block.querySelector(".wv-image-overlay");

    if (topOverText) {
      gsap.set(topOverText, {
        opacity: 0,
        y: 30,
      });
    }

    if (title) {
      gsap.set(title, {
        opacity: 0,
        y: 40,
      });
    }

    if (items.length) {
      gsap.set(items, {
        opacity: 0,
        y: 50,
      });
    }

    if (marqueeBlock) {
      gsap.set(marqueeBlock, {
        opacity: 0,
        y: 40,
      });
    }

    if (marqueeLines.length) {
      gsap.set(marqueeLines, {
        opacity: 0,
        y: 30,
      });
    }

    if (overlay) {
      gsap.set(overlay, {
        opacity: 0,
      });
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top 75%",
        once: true,
      },
      defaults: {
        ease: "power3.out",
      },
    });

    if (overlay) {
      tl.to(
        overlay,
        {
          opacity: 0.5,
          duration: 0.8,
        },
        0
      );
    }

    if (topOverText) {
      tl.to(
        topOverText,
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
        },
        0.1
      );
    }

    if (title) {
      tl.to(
        title,
        {
          opacity: 1,
          y: 0,
          duration: 0.75,
        },
        "-=0.3"
      );
    }

    if (items.length) {
      tl.to(
        items,
        {
          opacity: 1,
          y: 0,
          duration: 0.55,
          stagger: 0.12,
        },
        "-=0.25"
      );
    }

    if (marqueeBlock) {
      tl.to(
        marqueeBlock,
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
        },
        "-=0.35"
      );
    }

    if (marqueeLines.length) {
      tl.to(
        marqueeLines,
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.08,
        },
        "-=0.45"
      );
    }
  });
};

window.addEventListener("load", initServiceListAnimation);